import axios from "axios";
import apiBuilder, { URL_PREFIX } from "./apiBuilder";
import "./axiosClient";
import transaction from "./transaction";
import user from "./user";

const auth = {
  login: async ({ username, password }) => {
    try {
      const res = await axios.post(`${URL_PREFIX}/login`, {
        userid: username,
        password
      });

      const { authToken } = res.data;

      if (!authToken) throw new Error("Invalid credentials");
      return res.data;
    } catch (error) {
      throw new Error("Invalid credentials.");
    }
  }
};

const productType = apiBuilder("producttypes");
const expenseType = apiBuilder("expensetypes");
const expense = apiBuilder("expenses");

const product = {
  fetchById: id =>
    axios.get(`${URL_PREFIX}/woo-products/${id}`),

  fetchAll: () =>
    axios.get(`${URL_PREFIX}/woo-products?per_page=100&page=1`),

  fetchPage: (page = 1, perPage = 20, category, search = "") => {
    const params = new URLSearchParams();

    params.append("page", page);
    params.append("per_page", perPage);

    if (category !== null && category !== undefined) {
      params.append("category", category);
    }

    if (search) {
      params.append("q", search);
    }

    return axios.get(`${URL_PREFIX}/woo-products?${params.toString()}`);
  },

  fetchCategories: () =>
    axios.get(`${URL_PREFIX}/woo-products/categories`),

  searchByIdAndGetByPages: id =>
    axios.get(
      `${URL_PREFIX}/woo-products?q=${encodeURIComponent(id)}&per_page=10&page=1`
    ),

  searchByIdAndGetAll: id =>
    axios.get(
      `${URL_PREFIX}/woo-products?q=${encodeURIComponent(id)}&per_page=100&page=1`
    )
};

const customer = apiBuilder("customers");
const vendor = apiBuilder("vendors");
const receiving = apiBuilder("receivings");

export default {
  auth,
  productType,
  product,
  expense,
  expenseType,
  vendor,
  receiving,
  transaction,
  user
};
